export enum Role {
    Admin = 0,
    Reader = 1,
    User = 2
}
